import { all, fork } from 'redux-saga/effects';
import authSaga from './login/saga';

export function* rootSaga() {
  yield all([fork(authSaga)]);
}